module.exports = __webpack_public_path__ + "img/lucky7daily_bg.f503314c.png";